import { Component, OnInit } from '@angular/core'; // Added OnInit import
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { FooterComponent } from './components/footer/footer.component';
import { CommonModule } from '@angular/common';
import { ConstantsService } from './constants/constants.service';
import { filter } from 'rxjs/operators';
import { IdleService } from './services/idle.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, SidebarComponent, FooterComponent, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit { // Added OnInit implementation
  title = 'periscope-ui';
  
  constructor(private router: Router, public constants: ConstantsService, private idleService: IdleService) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.handleNavigation();
    });
  }
  
  ngOnInit(): void {
    setTimeout(() => this.handleNavigation(), 1000);
  }
  
  handleNavigation(): void {
    const storage = this.constants.getSession();
    const isMobile = window.innerWidth <= 768;
    
    if (this.isPublicVisitPage()) {
      return;
    }
    
    if ((this.router.url === '/' || this.router.url === '') && !storage) {
      if (isMobile) {
        this.router.navigate(['/splash']);
      } else {
        this.router.navigate(['/login']);
      }
    }
  }
  
  isPublicVisitPage(): boolean {
    return this.router.url.includes('/visit-invite-form/');
  }
  
  showUserLogin() {
    if (this.isPublicVisitPage()) {
      return false;
    }
    
    const storage = this.constants.getSession();
    if (!storage ||
        this.router.url === '/' ||
        this.router.url === '/login' ||
        this.router.url === '/register' ||
        this.router.url === '/forgot-password' ||
        this.router.url === '/splash') {
      return false;
    } else {
      return true;
    }
  }
  
  onMainWrapperClick(event: MouseEvent) {
    const sidebar = document.querySelector('#sidebar');
    const target = event.target as HTMLElement;
    
    if (sidebar && !sidebar.contains(target) && !target.closest('.sidebartoggler')) {
      const wrapper = document.getElementById('main-wrapper');
      if (wrapper) {
        wrapper.classList.remove('show-sidebar');
      }
    }
  }
}